import { useAppStore } from "@reactables/react";
import ButtonEdit from "Features/Shared/Components/ButtonEdit";
import { AppState } from "Features/Shared/Rx/RxApp";
import { ContactType } from "Constants/contactTypes";
import { RxCoverageApplicationProp } from "../../../Rx/RxCoverageApplication/RxCoverageApplication";
import * as FormSelectors from "../../../Rx/RxCoverageApplication/Selectors/form.selector";
import { Token } from "Features/CoverageApplication/Models/applicationForm.model";
import CCFields from "./CCFields";

const PaymentInformation = ({
  rxCoverageApplication,
}: {
  rxCoverageApplication: RxCoverageApplicationProp;
}) => {
  const [appState] = useAppStore<AppState>();
  const usStates = appState?.usStates.data;

  const [state, actions] = rxCoverageApplication;

  if (!usStates) return;

  const { payment, insuranceContact, insured } =
    FormSelectors.getRootValue(state);

  const enabled = FormSelectors.getControl(
    state,
    "insuranceContact.confirmed",
  ).touched;

  return (
    <div className={`component ${enabled ? "enabled" : "disabled"}`}>
      <div className="form-row justify-content-between">
        <div className="col-auto my-auto">
          <h3>Payment Information</h3>
        </div>
        <ButtonEdit
          edit={() => {
            actions.applicationForm.updateValues({
              controlRef: ["payment", "confirmed"],
              value: false,
            });
          }}
          show={payment.confirmed}
        />
      </div>
      <div className="card">
        <div className="card-body">
          {payment.confirmed ? (
            <>
              <div>
                <p className="font-weight-bold">Credit Card</p>
                <div>{payment.billing.creditCard.cardName}</div>
                <div>{(payment.token as Token)?.maskedPan}</div>

                <p className="font-weight-bold mt-3">Billing to</p>
                {payment.billing.sameAddressAsContact && (
                  <>
                    <p>
                      {insuranceContact.firstName} {insuranceContact.lastName}
                    </p>
                    {insuranceContact.differentAddressFields ? (
                      <>
                        {insuranceContact.differentAddressFields
                          .companyName && (
                          <p>
                            {
                              insuranceContact.differentAddressFields
                                .companyName
                            }
                          </p>
                        )}
                        <p>
                          {
                            insuranceContact.differentAddressFields.address
                              .address
                          }
                        </p>
                        <p>{`${insuranceContact.differentAddressFields.address.city}, ${insuranceContact.differentAddressFields.address.state}, ${insuranceContact.differentAddressFields.address.zip}, US`}</p>
                      </>
                    ) : (
                      <>
                        <p>{insured.address.address}</p>
                        <p>
                          {`${insured.address.city}, ${insured.address.state}, ${insured.address.zip}, US`}
                        </p>
                      </>
                    )}
                  </>
                )}
                {payment.billing.differentAddressFields && (
                  <>
                    {payment.billing.differentAddressFields.type ===
                    ContactType.Person ? (
                      <p>{`${payment.billing.differentAddressFields.firstName} ${payment.billing.differentAddressFields.lastName}`}</p>
                    ) : (
                      <p>
                        {payment.billing.differentAddressFields.companyName}
                      </p>
                    )}
                    <p>
                      {payment.billing.differentAddressFields.address.address}
                    </p>
                    <p>{`${payment.billing.differentAddressFields.address.city}, ${payment.billing.differentAddressFields.address.state}, ${payment.billing.differentAddressFields.address.zip}, US`}</p>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {enabled && (
                <CCFields rxCoverageApplication={rxCoverageApplication} />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentInformation;
